export default {
  description: `İlk okuduğum kitap, okulun kütüphanesinden aldığım Pinokyo’ydu. Büyük boy bir kitaptı. Bütün yaz bende kaldı. Üç ay boyunca kitabın kahramanlarıyla gezdim, dolaştım. Kederlerimi ve sevinçlerimi onlarla paylaştım.<nl> İlk satın aldığım kitap, Balonla Beş Hafta’ydı. Daha önce okuduğum bazı kitaplarda olduğu gibi bu kitabın da tesirinde kalarak balonla uçtuğumu hayal ettim. Kapağında renkli ve kendine özgü bir resim olan bu kitabı, okuduktan kısa bir süre sonra kaybettim.`,
  title: `Bu iki metinde bahsedilen kitapların ortak yönü aşağıdakilerden hangisidir?`,
  options: [
    {
      title: `Okuyucusunu etkilemeleri`,
      isTrue: true
    },
    {
      title: `Tavsiye üzerine alınmaları`,
      isTrue: false
    },
    {
      title: `Okuma alışkanlığı kazandırmaları`,
      isTrue: false
    },
    {
      title: `İlgi çekici görsellerle desteklenmeleri`,
      isTrue: false
    }
  ],
  id: 4
};



// WEBPACK FOOTER //
// ./src/assets/sorular/lgs/4.js